import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux"
//UI
import { Table, Segment, Header, Button, Input, Message, Icon, Form } from "semantic-ui-react";
import CircularProgress from "@material-ui/core/CircularProgress";
import "../../../styles/common.css";
import { scrollToTop } from "../../../resources/utils";
import { fetchYachts } from "../../../../redux/actions/catalogs/yacht/fetchYachts";
import { initialStateYacht } from "../../../../redux/actions/catalogs/yacht/fetchYacht";
import { useForm } from "react-hook-form";
import { fetchAvailability, initialStateAvailability } from "../../../../redux/slices/custom/reservations/cruise/availability/avalability.slice";
import { fetchAvalabilityReportReport, initialStateAvalabilityReport } from "../../../../redux/slices/custom/reservations/cruise/availability/avalabilityReport.slice";

export default function AvailabilityList() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { register, handleSubmit, errors } = useForm();
  const yachtState = useSelector((state) => state.yachtsReducer);
  const availabilityState = useSelector((state) => state.avalability);
  const reportState = useSelector((state) => state.avalabilityReport);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [cruiseYacht, setCruiseYacht] = useState("")
  const [cruiseYachtId, setCruiseYachtId] = useState("")

  useEffect(() => {
    dispatch(fetchYachts());
    scrollToTop();
    return () => {
      dispatch(initialStateYacht());
      dispatch(initialStateAvailability());
      dispatch(initialStateAvalabilityReport());
    };
  }, []);

  if (availabilityState.fetching || yachtState.fetching) {
    return <CircularProgress />;
  }

  const onSubmit = (data) => {

    dispatch(fetchAvailability(data.yacht_id, data.start_date, data.end_date));
  };

  const handleGenerateReport = () => {
    dispatch(fetchAvalabilityReportReport(cruiseYachtId, startDate, endDate)
    );
  };

  return (
    <>
      {availabilityState.error ? (
        <Message negative content={t(availabilityState.error)} />
      ) : (
        ""
      )}
      <Segment className="flex items-center justify-between">
        <div className="ui breadcrumb">
          <div className="active section text-lg">{t("availabilityReport_tag")} </div>
        </div>
        <Header as='h5' floated='right' className="flex items-center gap-2">
          <Form onSubmit={handleSubmit(onSubmit)} className="flex gap-1">
            <div className="flex flex-col">
              <label className="text-gray-500">{t("advance_report_yacht")}</label>
              <select name="yacht_id" className="ui selection dropdown font-normal" aria-expanded="true"
                style={{ padding: '3px 5px' }}
                ref={register({ required: true })}
                defaultValue={cruiseYachtId}
                onChange={
                  e => {
                    setCruiseYachtId(e.target.value)
                    setCruiseYacht(e.target.selectedOptions[0].getAttribute('data-name'))
                  }

                }
              >
                <option></option>
                {yachtState.yachts.map((yacht) => (
                  <option key={yacht.id} value={yacht.id} data-name={yacht.name}>{yacht.name}</option>
                ))}
              </select>
              {errors.yacht_id && (<span className="error_message">{t("required_information")}</span>)}
            </div>
            <Input type="date" className="flex flex-col">
              <label className="font-semibold text-gray-500">{t("statistic_startDate")}</label>
              <input
                value={startDate}
                onChange={e => setStartDate(e.target.value)}
                name="start_date"
                ref={register({ required: true })}
              />
              {errors.start_date && (<span className="error_message">{t("required_information")}</span>)}
            </Input>
            <Input type="date" className="flex flex-col">
              <label className="font-semibold text-gray-500">{t("statistic_endDate")}</label>
              <input
                value={endDate}
                onChange={e => setEndDate(e.target.value)}
                name="end_date"
                ref={register({ required: true })}
              />
              {errors.end_date && (<span className="error_message">{t("required_information")}</span>)}
            </Input>
            <div className="flex mt-[17px]">
              <Button
                type="submit"
                className={
                  availabilityState.fetching
                    ? "ui loading primary button"
                    : "ui primary button"
                }>
                <Icon name="file alternate" />
                {t("generate_report_button")}
              </Button>
            </div>
          </Form>
          <div className="flex mt-[17px]">
            <Button
              onClick={() => handleGenerateReport()}
              type="button"
              className={
                reportState.processing
                  ? "ui loading primary button"
                  : "ui primary button"
              } style={{ backgroundColor: "#1BB394", color: "white" }}>
              <Icon name="file excel" />
              {t("excel_button")}
            </Button>
          </div>
        </Header>
      </Segment>
      <Segment className="flex flex-col items-center justify-center">
        <h2 className="uppercase text-gray-500">{t("availabilityReport_tag")}{cruiseYacht && ` - ${cruiseYacht}`}</h2>
      </Segment>
      <Table color="blue" striped>
        <Table.Header align="left">
          <Table.Row>
            <Table.HeaderCell>{t("CRUISE")}</Table.HeaderCell>
            <Table.HeaderCell>{t("YACHT")}</Table.HeaderCell>
            <Table.HeaderCell>{t("IN")}</Table.HeaderCell>
            <Table.HeaderCell>{t("OUT")}</Table.HeaderCell>
            <Table.HeaderCell>{t("TYPE")}</Table.HeaderCell>
            <Table.HeaderCell>{t("SPACES")}</Table.HeaderCell>
            <Table.HeaderCell>{t("CABINS")}</Table.HeaderCell>
            <Table.HeaderCell>{t("ITINERARY")}</Table.HeaderCell>
          </Table.Row>
        </Table.Header>
        <Table.Body align="left">
          {availabilityState.items.map((cruise) => (
            <Table.Row key={cruise.id}>
              <Table.Cell className=" font-semibold">{cruise.code}</Table.Cell>
              <Table.Cell>{cruise.yacht}</Table.Cell>
              <Table.Cell>{cruise.startDate}</Table.Cell>
              <Table.Cell>{cruise.endDate}</Table.Cell>
              <Table.Cell>{cruise.type}</Table.Cell>
              <Table.Cell>{cruise.spaces}</Table.Cell>
              <Table.Cell>{cruise.cabins}</Table.Cell>
              <Table.Cell>{cruise.itinerary}</Table.Cell>
            </Table.Row>
          ))}
        </Table.Body>
      </Table>
    </>
  );
}
